module.exports = __webpack_public_path__ + "static/media/kitty-cat.b0dbed26.gif";